// extracted by mini-css-extract-plugin
module.exports = {" _key":"world-clock/app","clocks":"app-m__clocks__1ggEF","formFields":"app-m__formFields__BdEeH","formField":"app-m__formField__3QzG3"};